import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/client/reservation';

const list = (
	merchantId,
	branchId,
	processType = 1,
	startBookingDate = null,
	endBookingDate = null
) => {
	return Client.get(`${baseUrl}/order/list`, {
		merchantId,
		branchId,
		startBookingDate,
		endBookingDate,
		processType,
	});
};

const find = (merchantId, branchId, reservationId) => {
	return Client.get(`${baseUrl}/order/detail`, {
		merchantId,
		branchId,
		reservationId,
	});
};

const place = (payload) => {
	return Client.post(`${baseUrl}/order/place`, payload);
};

const modify = (payload) => {
	return Client.post(`${baseUrl}/order/modify`, payload);
};

const migrateTable = (
	merchantId,
	branchId,
	reservationId,
	tableCode,
	agreeOverbook,
	operateBy
) => {
	return Client.post(`${baseUrl}/order/modify/table`, {
		merchantId,
		branchId,
		reservationId,
		tableCode,
		agreeOverbook,
		operateBy,
	});
};

const swapTable = (data) => {
	return Client.post(`${baseUrl}/order/swap-table`, data);
};

const cancel = (
	merchantId,
	branchId,
	reservationId,
	amount,
	operateBy,
	reason = ''
) => {
	return Client.post(`${baseUrl}/order/cancel`, {
		merchantId,
		branchId,
		reservationId,
		amount,
		reason,
		operateBy,
	});
};

const accept = (merchantId, branchId, reservationId, operateBy) => {
	return Client.post(`${baseUrl}/order/accept`, {
		merchantId,
		branchId,
		reservationId,
		operateBy,
	});
};

const checkin = (merchantId, branchId, reservationId, operateBy) => {
	return Client.post(`${baseUrl}/order/check-in`, {
		merchantId,
		branchId,
		reservationId,
		operateBy,
	});
};

const undoCheckin = (data) => {
	return Client.post(`${baseUrl}/order/undo-check-in`, data);
};

const avaliableTime = (merchantId, branchId, numberOfPeople, bookingDate) => {
	return Client.get(`${baseUrl}/${merchantId}/reserve-time-list`, {
		branchId,
		numberOfPeople,
		bookingDate,
	});
};

const tags = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/tags`, { merchantId, branchId });
};

const estRefund = (merchantId, branchId, reservationId) => {
	return Client.get(`${baseUrl}/refund-deposit`, {
		merchantId,
		branchId,
		reservationId,
	});
};

const tablesets = (merchantId, branchId, areaCode) => {
	return Client.get(`${baseUrl}/table-picture`, {
		merchantId,
		branchId,
		areaCode,
	});
};

const tablesetStatus = (
	merchantId,
	branchId,
	numberOfPeople,
	startTime,
	endTime,
	tagId
) => {
	return Client.get(`${baseUrl}/table-booking-status`, {
		merchantId,
		branchId,
		numberOfPeople,
		startTime,
		endTime,
		tagId,
	});
};

const allocateTable = (data) => {
	return Client.get(`${baseUrl}/table-ai-booking`, data);
};

const rule = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/setting-info`, { merchantId, branchId });
};

const depositRule = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/deposit-setting`, { merchantId, branchId });
};

const reservedNumberOfPeople = (merchantId, branchId, startTime, endTime) => {
	return Client.get(`${baseUrl}/reserved-number`, {
		merchantId,
		branchId,
		startTime,
		endTime,
	});
};

export default {
	list,
	find,
	place,
	modify,
	migrateTable,
	swapTable,
	accept,
	checkin,
	undoCheckin,
	cancel,
	avaliableTime,
	tags,
	estRefund,
	tablesets,
	tablesetStatus,
	allocateTable,
	rule,
	depositRule,
	reservedNumberOfPeople,
};
